
(function() {
  var module = {};
  var result = {};
  module.exports = { "en": { "i18n": { "duration": { "seconds": "{{ seconds }} sec", "minutes": "{{ minutes }} min", "hours": "{{ hours }} hr", "hoursAndMinutes": "{{ hours }} hr {{ minutes }} min", "days": "{{ days }} days", "shortForm": { "seconds": "{{ seconds }}s", "minutes": "{{ minutes }}m", "hours": "{{ hours }}h", "days": "{{ days }}d", "hoursAndMinutes": "{{ hours }}h {{ minutes }}m" } }, "dateTime": { "shortForm": { "months": { "january": "Jan", "february": "Feb", "march": "Mar", "april": "Apr", "may": "May", "june": "Jun", "july": "Jul", "august": "Aug", "september": "Sep", "october": "Oct", "november": "Nov", "december": "Dec" } }, "monthAndDay": "{{monthName}} {{dayNumber}}", "monthAndYear": "{{monthName}} {{yearNumber}}", "weekDayAndMonthAndDayAndYear": "{{weekDay}}, {{fullDate}}", "quarterAndYear": "Q{{quarterNumber}} {{yearNumber}}" }, "numberRepresentation": { "fraction": "{{ numerator }}/{{ denominator }}", "numberWithCurrencyCode": "{{currencyCode}} {{amountNumberValue}}", "phoneNumberWithExtension": "{{phoneNumber}}, ext. {{extension}}" } } } };
  result.translations = module.exports;
  result.translationsLoaded = {
  "I18n": {
    "en": "static-7.520"
  }
};
  result.translationsAvailable = {
  "I18n": {
    "cs": "static-7.520",
    "da": "static-7.520",
    "de": "static-7.520",
    "el": "static-7.520",
    "en": "static-7.520",
    "es-mx": "static-7.520",
    "es": "static-7.520",
    "fi": "static-7.520",
    "fr": "static-7.520",
    "hr": "static-7.520",
    "id": "static-7.520",
    "it": "static-7.520",
    "ja": "static-7.520",
    "ko": "static-7.520",
    "nl": "static-7.520",
    "no": "static-7.520",
    "pl": "static-7.520",
    "pt-br": "static-7.520",
    "ro": "static-7.520",
    "ru": "static-7.520",
    "sv": "static-7.520",
    "th": "static-7.520",
    "vi-vn": "static-7.520",
    "zh-cn": "static-7.520",
    "zh-hk": "static-7.520"
  }
};
  hns('I18n', result);
  if (typeof I18n === 'object' && I18n.trigger) { I18n.trigger('loaded:I18n:en', {version: 'static-7.520'}); }
})();





//////////////////
// WEBPACK FOOTER
// ../node_modules/bender-lyaml-loader/lib?{"allowJsx":true,"modern":false}!/usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.520/lang/en.lyaml?sporks
// module id = 65
// module chunks = 177 178